<template>
    <v-footer
        app
        absolute
        dark
        height="auto"
    >
        <v-card
            class="white--text"
            style="background-color: #212121; width: 100%"
        >
            <v-card-text class="text-xs-center">
                <v-btn
                    v-for="(icon, index) in icons"
                    :key="index"
                    class="mx-3 white--text"
                    icon
                    @click="changeLocation(icon.route)"
                >
                    <v-icon size="24px">{{ icon.icon }}</v-icon>
                </v-btn>
            </v-card-text>

            <v-card-text class="white--text pt-0">
                <v-container>
                    <v-layout row wrap class="footer-link-layout">
                        <div class="footer-links">
                            <div class="body-2">More Info</div>
                            <!--<div class="caption footer-link">About vorsi.io</div>-->
                            <div class="caption footer-link" @click="changeLocation('/contact-us')">Contact Us</div>
                        </div>
                        <div class="footer-links">
                            <div class="body-2">Legal</div>
                            <a href="https://vorsi-home.s3.amazonaws.com/vorsi-MSA.docx" download="vorsi-MSA.docx"
                               style="text-decoration: none" class="caption footer-link">Terms Of Use</a>
                            <div class="caption footer-link" @click="privacyPolicy = true">Privacy Policy</div>
                        </div>
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="white--text text-xs-center">
                <span
                    style="text-decoration: none; padding-right: 15px">Vorsi.io &copy; 2019 - {{ getCurrentYear() }}</span>
            </v-card-text>
        </v-card>
        <vorsi-privacy-policy :dialog="privacyPolicy" @togglePrivacyPolicy="togglePrivacyPolicy"></vorsi-privacy-policy>
    </v-footer>
</template>

<script>
Vue.component('vorsi-privacy-policy', require('./PrivacyPolicy.vue').default);

export default {
    data: () => ({
        termsOfService: false,
        privacyPolicy: false,
        icons: [
            {icon: 'mdi-facebook', route: 'https://www.facebook.com/getVorsi'},
            {icon: 'mdi-twitter', route: 'https://twitter.com/getVorsi'},
            {icon: 'mdi-google', route: 'https://www.google.com/search?q=vorsi'},
            {icon: 'mdi-instagram', route: 'https://www.instagram.com/vorsi_software'},
        ]
    }),
    methods: {
        changeLocation(route) {
            window.location = route
        },
        togglePrivacyPolicy(value) {
            this.privacyPolicy = value
        },
        getCurrentYear() {
            return new Date().getFullYear()
        }
    }
}
</script>

<style scoped>

</style>
